import { render, staticRenderFns } from "./extendadd.vue?vue&type=template&id=dff4537c&scoped=true"
import script from "./extendadd.vue?vue&type=script&lang=js"
export * from "./extendadd.vue?vue&type=script&lang=js"
import style0 from "./extendadd.vue?vue&type=style&index=0&id=dff4537c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff4537c",
  null
  
)

export default component.exports